module.exports = __webpack_public_path__ + "img/Modus-Labs-Logo.df9a8ca3.svg";